module.exports = __webpack_public_path__ + "static/media/flag-red.ce221b4c.svg";